import React , {useEffect, useState} from 'react';
import * as CONSTANTS from '../../utils/CONSTANTS'
import { makeSideBarActive } from '../../utils/EllowUtils';
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import CreateCompanies from './createCompany';
import { submitCompanyDetails, getRecruiterList } from './services';
import { useNavigate } from 'react-router-dom';
import NotificationAlert from "../../components/notification";
import mixpanelData, { viewedpageMixpanel } from '../../utils/mixpanel';


function CreateCompany() {

  const navigate = useNavigate()
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 3)
  const BreadcrumsValues = ['Companies', 'Create New Company']
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [flag , setFlag] = useState<boolean>(false)
  const [recruitersList , setRecruitersList] = useState<any>()
  const [disable , setDisable] = useState<boolean>(false)
  const [error, setError] = useState<boolean>(false)
  
  const submitCompany = (data: any) => { 
    let name = data.behalfofName
    delete  data.behalfofName  
    setDisable(true)
    submitCompanyDetails(data).then((response) => {
      if (response && response.status === 1) {
        setError(false)
        setDisable(false)
        displayNotification()
        mixpanelData('TG - Company Created', {
          'source': 'Recruiter creates a company',
          "honorific": data.customerMetadata.honorific,
          "name": data.customerMetadata.firstName + ' ' + data.customerMetadata.lastName,
          "workEmail": data.customerMetadata.workEmail.toLowerCase(),
          "companyName": data.customerMetadata.companyName,
          "phone": data.customerMetadata.phoneNumber,
          'distinct_id': localStorage.getItem('Email'),
          'Recruiter email': localStorage.getItem('Email'),
          "Date": new Date().toDateString(),
          "companyType": data.companyType === 1 ? 'Hirer' : data.company === 2 ? 'Provider' : 'Both',
          "companyId": response && response.data.customer_id,
          "sourced by": data.sourcedBy
        })
        mixpanelData('New TG - Company Created', {
          'source': 'Recruiter creates a company',
          "Honorific": data.customerMetadata.honorific,
          "Name": data.customerMetadata.firstName + ' ' + data.customerMetadata.lastName,
          "User email": data.customerMetadata.workEmail.toLowerCase(),
          "Company name": data.customerMetadata.companyName,
          "Phone number": data.customerMetadata.phoneNumber,
          'distinct_id': localStorage.getItem('Email'),
          'Recruiter email': localStorage.getItem('Email'),
          "Date": new Date().toDateString(),
          "Company type": data.companyType === 1 ? 'Hirer' : data.company === 2 ? 'Provider' : 'Both',
          "Company id": response && response.data.customer_id,
          "Sourced by": data.sourcedBy,
          "Source name": name
        })
        mixpanelData('TG - Company Approve/Reject', {
          'source': `Recruiter Approves a company `,
          'status': 'Approved',
          'Company Name': data.customerMetadata.companyName,
          'distinct_id': localStorage.getItem('Email'),
          "Date": new Date().toDateString(),
          "companyType": data.companyType === 1 ? 'Hirer' : 'Provider',
          "companyId": response && response.data.customer_id,
        })

        mixpanelData('New TG - Company Approved', {
          'source': `Recruiter Approves a company `,
          'Status': 'Approved',
          'Company name': data.customerMetadata.companyName,
          'distinct_id': localStorage.getItem('Email'),
          'Verified by': localStorage.getItem('Email'), 
          "User email": data.customerMetadata.workEmail.toLowerCase(),
          "Company type": data.companyType === 1 ? 'Hirer' : 'Provider',
          "Company id": response && response.data.customer_id,
          "Sourced by": data.sourcedBy,
          "Source name": name,
          "Section": 'Create company'
        })
      }
      else {
        setError(true)
        setMessage(response.error.data)
      }
  })
  }

  const displayNotification = () => {
    setMessage('Details saved successfully')
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
      navigate('/company')
     }, 3000)  
  }

  useEffect(() => {
    viewedpageMixpanel();
    recruiterList()
  }, [])

  const recruiterList = () => {
    getRecruiterList().then((respose: any) => {
      if(respose && respose.status === 1){
        setRecruitersList(respose.data)
      }
    })
  }
  
  const onClose = () => {
    setNotification(false)
  }

  return (
    <section className="dashboardWrapper">
      {notification && <NotificationAlert onClose={onClose } closable={true} >
        {message}
      </NotificationAlert> }
    <SideMenu menu={menu}/>
    <div className="dashboardContent">
      <DashboardHeader
          searchChange={undefined}
          title={BreadcrumsValues}
      />
      {/* <iframe src={`https://embedded.hellosign.com/prep-and-send/embedded-request?cached_params_token=f64d90af5f290559ddbf92c58de71e61#view=fitH`} title="testPdf" height="100%" width="100%" /> */}
        <CreateCompanies disable={disable} submitCompany={submitCompany} error={{error: error, message: message}} recruitersList={recruitersList} />
      </div>
  </section>
  )
}

export default CreateCompany